module.exports = __webpack_public_path__ + "static/media/full-screen-exit.bb435cb7.svg";